theme.shoppingControls = (function() {
    var _shoppingControls = {};
    _shoppingControls.$quantity = $('#buy-now-button__wrapper');
    _shoppingControls.$totalOfSet = $('#ProductPrice');
    _shoppingControls.$errorContainer = $('.cart-errors');
    _shoppingControls.totalCounter = 0;

    _shoppingControls.getCartItemObject  = function(targetEl) {
        var $control = $(targetEl).closest('[data-quantity-shopping-container]');
        var productId = $control.find('[name="id"]').val();
        var $qtyInput = $control.find('[data-quantity]');
        var $qtyProxy = $control.find('[data-quantity-text]');
        var qty = parseInt($qtyInput.attr('data-quantity'));
        var stock = parseInt($qtyInput.attr('data-stock'));
        var productPrice = parseFloat($control.find('[data-item-price]').attr('data-item-price'), 2);

        return {
            $control: $control,
            id: productId,
            qty: qty,
            stock: stock,
            $qtyInput: $qtyInput,
            $qtyProxy: $qtyProxy,
            productPrice: productPrice
        }
    }

    _shoppingControls.registerControls = function(){
        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="sub"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty - 1 > 0 ? cartItem.qty - 1 : 0;
            var oldQty = cartItem.qty;
            var operator = $(this).attr('data-quick-shopping-control');
            if (newQty < oldQty) {
                _shoppingControls.getTotal(operator, cartItem.productPrice, 1);
                _shoppingControls.$errorContainer.html('');
            }
            cartItem.$qtyInput.attr('data-quantity', newQty);
            cartItem.$qtyProxy.html(newQty);
        });

        _shoppingControls.$quantity.on('click', '[data-quick-shopping-control="add"]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newQty = cartItem.qty + 1 <= cartItem.stock ? cartItem.qty + 1 : cartItem.qty;
            var operator = $(this).attr('data-quick-shopping-control');
            cartItem.$qtyInput.attr('data-quantity', newQty);
            cartItem.$qtyProxy.html(newQty);
            if (cartItem.$qtyInput.attr('data-quantity') > 0) {
                _shoppingControls.getTotal(operator, cartItem.productPrice, 1);
                _shoppingControls.$errorContainer.html('');
            }

            $(window).trigger('dataLayer-add-update-qnty', newQty);
        });

        _shoppingControls.$quantity.on('input', '[data-quantity-mobile-input]', function(){
            var cartItem = _shoppingControls.getCartItemObject(this);
            var newInput = 0;
            if (!isNaN($(this).val()) && $(this).val() != '') {
                newInput = $(this).val();
            }
            var newQty = newInput <= cartItem.stock ? newInput : cartItem.stock;
            if(newInput <= cartItem.stock) {
                newQty = newInput;
            } else {
                newQty = cartItem.stock;
                $(this).val(cartItem.stock);
            }
            if (newQty < 0) {
                $(this).val(0);
                newQty = 0;
            }
            var oldQty = cartItem.qty;
            let qtyGap = 0;
            if (newQty < oldQty) {
                qtyGap = oldQty - newQty;
                _shoppingControls.getTotal("sub", cartItem.productPrice, qtyGap);
                _shoppingControls.$errorContainer.html('');
            } else if (newQty > oldQty) {
                qtyGap = newQty - oldQty;
                _shoppingControls.getTotal("add", cartItem.productPrice, qtyGap);
                _shoppingControls.$errorContainer.html('');
            }
            cartItem.$qtyInput.attr('data-quantity', newQty);
            cartItem.$qtyProxy.html(newQty);
        });
    };

    _shoppingControls.getTotal = function(operator, productPrice, qty) {
        let priceToUse = productPrice * qty;
        if (operator == 'add') {
            _shoppingControls.totalCounter += priceToUse;
        } else {
            _shoppingControls.totalCounter -= priceToUse;
        }
        let totalWithCurrency = theme.Currency.formatMoney(_shoppingControls.totalCounter, theme.strings.moneyFormat);
        _shoppingControls.$totalOfSet.html(totalWithCurrency);
    }

    _shoppingControls.init = function() {
        if(!_shoppingControls.$quantity.length) {
            console.warn('Cart Error');
            return;
        } else {
            _shoppingControls.registerControls();
        }
    };

    return _shoppingControls;
})();

$(document).on("ready", function() {
    if ( $('.set-item__controls-wrapper').length ) {
        theme.shoppingControls.init();
    }

    var $addToCartButton = $('.btn__add-to-cart');
    var $errorContainer = $('.cart-errors');
    var $drawerCartButton = $('.js-drawer-open-button-right');

    if ($addToCartButton.length) {
        $addToCartButton.on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let formData = {
                'items': []
            };
            let $setItem = $('.set-products__item');
            $setItem.each(function() {
                let itemId = $(this).attr('data-quantity-shopping-container');
                let itemQty = parseInt($(this).find('span[data-target-input="qty"]').text());
                let finalProduct = {
                    id: itemId,
                    quantity: itemQty
                }
                if(itemQty != 0) {
                    formData.items.push(finalProduct)
                }
            })

            if (formData.items.length > 0) {
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => response.json())
                .then(json => {
                    if (json.status >= 400) {
                        throw json.description;
                    }
                    $drawerCartButton.trigger('click');
                })
                .catch((error) => {
                    $errorContainer.html($(`<p>${error}</p>` ));
                    console.error('Error:', error);
                });
            }
        })
    }

    $drawerCartButton.on('click', function(){
        if(!CSS.supports('overflow', 'clip')) {
            window.scroll(0, 0);
        }
    })
});
